import { render, staticRenderFns } from "./LessonMultiAudio.vue?vue&type=template&id=7480b773&scoped=true"
import script from "./LessonMultiAudio.vue?vue&type=script&lang=js"
export * from "./LessonMultiAudio.vue?vue&type=script&lang=js"
import style0 from "./LessonMultiAudio.vue?vue&type=style&index=0&id=7480b773&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480b773",
  null
  
)

export default component.exports